import React from "react";
import Icon, { type IconProps } from "./icon";

export default function DeweyLogo({ className, width = 33, height = 32 }: IconProps) {
  return (
    <Icon
      className={className}
      width={width}
      height={height}
      viewBox="0 0 33 32"
    >
      <mask
        id="mask0_4695_1177"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="4"
        width="24"
        height="24"
      >
        <circle
          cx="16.7527"
          cy="15.8684"
          r="11.6797"
          transform="rotate(118.883 16.7527 15.8684)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_4695_1177)">
        <rect
          x="51.0039"
          y="15.3998"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 51.0039 15.3998)"
          fill="#1A1A1A"
        />
        <rect
          x="42.6562"
          y="13.3756"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 42.6562 13.3756)"
          fill="#1A1A1A"
        />
        <rect
          x="41.5625"
          y="15.355"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 41.5625 15.355)"
          fill="#1A1A1A"
        />
        <rect
          x="43.7695"
          y="19.1542"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 43.7695 19.1542)"
          fill="#1A1A1A"
        />
        <rect
          x="46.6367"
          y="23.3174"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 46.6367 23.3174)"
          fill="#1A1A1A"
        />
        <rect
          x="38.2852"
          y="21.2931"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 38.2852 21.2931)"
          fill="#1A1A1A"
        />
        <rect
          x="37.1914"
          y="23.2725"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 37.1914 23.2725)"
          fill="#1A1A1A"
        />
        <rect
          x="39.4023"
          y="27.0717"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 39.4023 27.0717)"
          fill="#1A1A1A"
        />
        <rect
          x="35.0117"
          y="27.2312"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 35.0117 27.2312)"
          fill="#1A1A1A"
        />
        <rect
          x="26.6602"
          y="25.207"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 26.6602 25.207)"
          fill="#1A1A1A"
        />
        <rect
          x="25.5664"
          y="27.1864"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 25.5664 27.1864)"
          fill="#1A1A1A"
        />
        <rect
          x="27.7773"
          y="30.9856"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 27.7773 30.9856)"
          fill="#1A1A1A"
        />
        <rect
          x="30.6406"
          y="35.1487"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 30.6406 35.1487)"
          fill="#1A1A1A"
        />
        <rect
          x="22.293"
          y="33.1244"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 22.293 33.1244)"
          fill="#1A1A1A"
        />
        <rect
          x="21.1992"
          y="35.1039"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 21.1992 35.1039)"
          fill="#1A1A1A"
        />
        <rect
          x="23.4102"
          y="38.903"
          width="0.753527"
          height="39.9369"
          transform="rotate(118.883 23.4102 38.903)"
          fill="#1A1A1A"
        />
      </g>
    </Icon>
  );
}
